export default "__VITE_ASSET__CX6_xtFN__"